module.exports = __webpack_public_path__ + "static/img/jigou-henansheng-bottom.0aa8c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-henansheng-bottom.png
// module id = +3/Z
// module chunks = 2